import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardApi from "../../api/DashboardApi";

function SalesCard({ stats }) {
  const navigate = useNavigate();

  const [selected, setSelected] = useState("followup");

  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);

  const [search, setSearch] = useState("");

  const [keyword, setKeyword] = useState("");

  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    pages: 1,
    limit: 10,
  });

  /* ======================================
            BADGE COLOR
  ======================================= */

  const badgeColor = (value = "") => {
  switch (value.toLowerCase()) {
    case "interested":
      return "success";

    case "call back":
      return "warning";

    case "followup":
      return "info";

    case "overdue followup":
      return "danger";

    case "did not pick up":
      return "danger";

    default:
      return "primary";
  }
};

  /* ======================================
            LOAD DATA
  ======================================= */

  const loadData = async () => {
    try {
      setLoading(true);

     const dispositionMap = {
  followup: "Followup",
  callback: "Call Back",
  interest: "Interested",
  overdue: "Overdue Followup",
};

      const res = await DashboardApi.salesDispositionList({
        disposition: dispositionMap[selected],
        search,
        page,
        limit: 10,
      });

      if (res.success) {
        setRows(res.data || []);

        setPagination(
          res.pagination || {
            total: 0,
            page: 1,
            pages: 1,
            limit: 10,
          },
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  /* ======================================
            EFFECTS
  ======================================= */

  useEffect(() => {
    loadData();
  }, [selected, page, search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(keyword);
    }, 500);

    return () => clearTimeout(timer);
  }, [keyword]);

  useEffect(() => {
  const handleOverdueFollowups = () => {
    setSelected("overdue");
    setPage(1);
    setKeyword("");
    setSearch("");
  };

  window.addEventListener(
    "dashboard-overdue-followups",
    handleOverdueFollowups
  );

  return () => {
    window.removeEventListener(
      "dashboard-overdue-followups",
      handleOverdueFollowups
    );
  };
}, []);

  /* ======================================
            CARD CLICK
  ======================================= */

  const changeCard = (value) => {
    setSelected(value);

    setPage(1);

    setKeyword("");

    setSearch("");
  };

  /* ======================================
            JSX
  ======================================= */

  return (
    <>
      {/* ======================================
                TOP CARDS
      ======================================= */}

      <div className="row g-4 mb-4">
        {/* FOLLOWUP */}

        <div className="col-xl-3 col-md-6">
          <div
            className={`card border-0 shadow-sm sales-card ${
              selected === "followup" ? "sales-active-card" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => changeCard("followup")}
          >
            <div className="card-body text-center">
              <i
                className="ti ti-list-check"
                style={{
                  fontSize: 42,
                  color: "#5a140c",
                }}
              />

              <h2 className="fw-bold mt-3 mb-1">{stats?.followupCount ?? 0}</h2>

              <div
                className="progress mt-3"
                style={{
                  height: 6,
                }}
              >
                <div
                  className="progress-bar"
                  style={{
                    width: "100%",
                  }}
                ></div>
              </div>

              <p className="text-muted mb-0">Total Followups</p>
            </div>
          </div>
        </div>

        {/* CALLBACK */}

        <div className="col-xl-3 col-md-6">
          <div
            className={`card border-0 shadow-sm sales-card ${
              selected === "callback" ? "sales-active-card" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => changeCard("callback")}
          >
            <div className="card-body text-center">
              <i
                className="ti ti-phone-call"
                style={{
                  fontSize: 42,
                  color: "#0d6efd",
                }}
              />

              <h2 className="fw-bold mt-3 mb-1">{stats?.callbackCount || 0}</h2>
              <div
                className="progress mt-3"
                style={{
                  height: 6,
                }}
              >
                <div
                  className="progress-bar"
                  style={{
                    width: "100%",
                  }}
                ></div>
              </div>

              <p className="text-muted mb-0">Call Back</p>
            </div>
          </div>
        </div>

        {/* INTERESTED */}

        <div className="col-xl-3 col-md-6">
          <div
            className={`card border-0 shadow-sm sales-card ${
              selected === "interest" ? "sales-active-card" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => changeCard("interest")}
          >
            <div className="card-body text-center">
              <i
                className="ti ti-heart-handshake"
                style={{
                  fontSize: 42,
                  color: "#198754",
                }}
              />

              <h2 className="fw-bold mt-3 mb-1">
                {stats?.interestedCount || 0}
              </h2>
              <div
                className="progress mt-3"
                style={{
                  height: 6,
                }}
              >
                <div
                  className="progress-bar"
                  style={{
                    width: "100%",
                  }}
                ></div>
              </div>
              <p className="text-muted mb-0">Interested</p>
            </div>
          </div>
        </div>

        {/* NOT PICKED */}

       {/* OVERDUE FOLLOWUPS */}

<div className="col-xl-3 col-md-6">
  <div
    className={`card border-0 shadow-sm sales-card ${
      selected === "overdue" ? "sales-active-card" : ""
    }`}
    style={{ cursor: "pointer" }}
    onClick={() => changeCard("overdue")}
  >
    <div className="card-body text-center">
      <i
        className="ti ti-clock-exclamation"
        style={{
          fontSize: 42,
          color: "#dc3545",
        }}
      />

      <h2 className="fw-bold mt-3 mb-1">
        {stats?.overdueFollowups || 0}
      </h2>

      <div
        className="progress mt-3"
        style={{
          height: 6,
        }}
      >
        <div
          className="progress-bar"
          style={{
            width: "100%",
          }}
        />
      </div>

      <p className="text-muted mb-0">
        Overdue Followups
      </p>
    </div>
  </div>
</div>
      </div>

      {/* ======================================
                DASHBOARD HEADER
      ======================================= */}

      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h3 className="fw-bold mb-1">Sales Dashboard</h3>

              <p className="text-muted mb-0">
                Monitor followups, callbacks and customer activity from one
                place.
              </p>
            </div>

            <div className="col-md-4 text-end">
              <button
                className="btn btn-primary"
                onClick={loadData}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="ti ti-refresh me-2"></i>
                    Refresh
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row g-3 mb-4">
        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/lead-management"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-user-plus fs-2 text-primary"></i>
              <h6 className="mt-3 mb-0">Add Lead</h6>
            </div>
          </Link>
        </div>

        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/followup"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-phone fs-2 text-success"></i>
              <h6 className="mt-3 mb-0">Followup</h6>
            </div>
          </Link>
        </div>

        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/meeting"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-video fs-2 text-danger"></i>
              <h6 className="mt-3 mb-0">Meeting</h6>
            </div>
          </Link>
        </div>

        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/document"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-file-text fs-2 text-warning"></i>
              <h6 className="mt-3 mb-0">Documents</h6>
            </div>
          </Link>
        </div>

        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/proposal"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-file-invoice fs-2 text-info"></i>
              <h6 className="mt-3 mb-0">Proposal</h6>
            </div>
          </Link>
        </div>

        <div className="col-xl-2 col-md-4 col-6">
          <Link
            to="/agreement"
            className="quick-card card border-0 shadow-sm text-decoration-none"
          >
            <div className="card-body text-center">
              <i className="ti ti-file-certificate fs-2 text-secondary"></i>
              <h6 className="mt-3 mb-0">Agreement</h6>
            </div>
          </Link>
        </div>
      </div> */}

      {/* ======================================
              TABLE START
      ======================================= */}

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold mb-0">
              {selected === "followup" && "Total Followups"}

              {selected === "callback" && "Call Back Leads"}

              {selected === "interest" && "Interested Leads"}

              {selected === "overdue" && "Overdue Followups"}
            </h5>

            <span className="badge bg-primary px-3 py-2">
              Total Records : {pagination.total}
            </span>
          </div>

          <input
            className="form-control"
            placeholder="Search by Lead Name or Mobile..."
            value={keyword}
            onChange={(e) => {
              setKeyword(e.target.value);
              setPage(1);
            }}
          />
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>

              <div className="mt-3 text-muted">Loading Leads...</div>
            </div>
          ) : (
            <>
              <div
                className="table-responsive"
                style={{
                  maxHeight: "550px",
                  overflowY: "auto",
                }}
              >
                <table className="table table-hover align-middle">
                  <thead
                    className="table-light"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    <tr>
                      <th style={{ width: "70px" }}>#</th>

                      <th>Lead Name</th>

                      <th>Mobile</th>

                      <th>Disposition</th>

                      <th>Remarks</th>

                      <th>Date</th>

                      <th
                        className="text-center"
                        style={{
                          width: "130px",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {rows.length === 0 && (
                      <tr>
                        <td colSpan={7} className="text-center py-5">
                          <i
                            className="ti ti-folder-off"
                            style={{
                              fontSize: 55,
                              color: "#d1d5db",
                            }}
                          />

                          <h5 className="mt-3">No Leads Found</h5>
                          <div className="mt-3">
                            <Link
                              to="/lead-management"
                              className="btn btn-primary"
                            >
                              Create New Lead
                            </Link>
                          </div>

                          <p className="text-muted">
                            There are no records for this disposition.
                          </p>
                        </td>
                      </tr>
                    )}

                    {rows.map((item, index) => (
                      <tr
                        key={item._id}
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(`/lead-details/${item.lead._id}`)
                        }
                      >
                        <td>{(page - 1) * pagination.limit + index + 1}</td>

                        <td>
                          <div>
                            <strong>{item?.lead?.name}</strong>
                          </div>
                        </td>

                        <td>{item?.lead?.phone}</td>

                        <td>
                          <span
                            className={`badge bg-${badgeColor(
                              item.disposition,
                            )}`}
                          >
                            {item.disposition}
                          </span>
                        </td>

                        <td>{item.remarks || "-"}</td>

                       <td>
  {new Date(
    selected === "overdue" && item.callback_date
      ? item.callback_date
      : item.createdAt
  ).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })}
</td>

                        <td className="text-center">
                          <Link
                            to={`/lead-details/${item.lead._id}`}
                            className="btn btn-sm btn-primary"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <i className="ti ti-eye me-1"></i>
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <hr />

              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div className="text-muted">
                  Showing
                  <b className="mx-1">{rows.length}</b>
                  of
                  <b className="mx-1">{pagination.total}</b>
                  Records
                </div>

                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-outline-secondary"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                  >
                    <i className="ti ti-chevron-left"></i>
                  </button>

                  <span className="mx-3 fw-bold">
                    Page {page} of{" "}
                    {Math.max(
                      1,

                      Math.ceil(pagination.total / pagination.limit),
                    )}
                  </span>

                  <button
                    className="btn btn-outline-secondary"
                    disabled={page >= (pagination.pages || 1)}
                    onClick={() => setPage(page + 1)}
                  >
                    <i className="ti ti-chevron-right"></i>
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default SalesCard;
